import type { RouteObject } from "react-router";
import { AutoPage } from "./pages/Auto";
import { CalendarPage } from "./pages/Calendar";
import { EditorPage } from "./pages/Editor";
import { ProjectsPage } from "./pages/Projects";
import { SettingsPage } from "./pages/Settings";
import { WritePage } from "./pages/Write";

export const routes: RouteObject[] = [
  { path: "write", element: <WritePage /> },
  { path: "posts/:id", element: <EditorPage /> },
  { path: "auto", element: <AutoPage /> },
  { path: "calendar", element: <CalendarPage /> },
  { path: "projects", element: <ProjectsPage /> },
  { path: "settings", element: <SettingsPage /> },
];
